const data = [
  { city: "New York City", pinCode: 10001, state: "New York", country: "USA" },
  { city: "Los Angeles", pinCode: 90001, state: "California", country: "USA" },
  { city: "Chicago", pinCode: 60007, state: "Illinois", country: "USA" },
//   { city: "Boston", pinCode: 02108, state: "Massachusetts", country: "USA" },
  {
    city: "San Francisco",
    pinCode: 94016,
    state: "California",
    country: "USA",
  },
  {
    city: "Washington, D.C.",
    pinCode: 20001,
    state: "Washington",
    country: "USA",
  },
  {
    city: "Philadelphia",
    pinCode: 19019,
    state: "Pennsylvania",
    country: "USA",
  },
  { city: "Houston", pinCode: 77001, state: "Texas", country: "USA" },
  { city: "Atlanta", pinCode: 30033, state: "Georgia", country: "USA" },
  { city: "Seattle", pinCode: 98101, state: "Washington", country: "USA" },
];
export default data;
